module.exports = __webpack_public_path__ + "img/pinchtap.d898e5f1.svg";